import { render, staticRenderFns } from "./AmountBoard.vue?vue&type=template&id=6ce13b74&"
import script from "./AmountBoard.vue?vue&type=script&lang=js&"
export * from "./AmountBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports